import React, { useRef, type CSSProperties, type ReactNode } from "react";
import { ToolbarAvoid } from "@autodromo/contextual-fields";
import { useSubmenuPlacement } from "../../../hooks/useSubmenuPlacement";
import { Submenu } from "../HeaderV2.styles";
import type { SubmenuStyle } from "../types";

type SubmenuPanelProps = {
  label: string;
  wide: boolean;
  columns: number;
  submenuStyle?: SubmenuStyle;
  children: ReactNode;
};

export const SubmenuPanel = ({ label, wide, columns, submenuStyle, children }: SubmenuPanelProps) => {
  const panelRef = useRef<HTMLDivElement | null>(null);
  const { shift, drop } = useSubmenuPlacement({ panelRef });

  return (
    <Submenu
      ref={panelRef}
      role="group"
      aria-label={label}
      $wide={wide}
      $columns={columns}
      $style={submenuStyle}
      data-toolbar-avoid={ToolbarAvoid.CONTENT}
      style={{ "--hv2-submenu-shift": `${shift}px`, "--hv2-submenu-drop": `${drop}px` } as CSSProperties}
    >
      {children}
    </Submenu>
  );
};
